module.exports = __webpack_public_path__ + "static/img/kapianwenli.bbdf539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/kapianwenli.png
// module id = xZ22
// module chunks = 16